import React from 'react'
import FileUploadButton from '../../../../file/upload/FileUploadButton'
import FileBdList from '../../../../file/bd/FileBdList'
import { useSelector } from 'react-redux'

const SupplyBillFilesBlock = ({ name, tableOwnerId, tableOwnerType = 'supplyBills', type }) => {
    
    const supplyBill = useSelector(state => state.supplyBill.supplyBill)

  return (
    <div className='fileListBlock'>
        <div className='fileListBlock__header'>
            <p>
                {name}
            </p>
            <FileUploadButton
                tableOwnerId={tableOwnerId}
                tableOwnerType={tableOwnerType}
                type={type}
            />
        </div>
        
        <FileBdList 
            type={type}
            files={supplyBill && supplyBill.files ? supplyBill.files : []}
        />
    </div>
  )
}

export default SupplyBillFilesBlock